import * as types from '../mutation-types'
import axios from 'axios'

// state
export const state = {
  navItems: [],
  mailUnreadCount: 0,
  chatUnreadCount: 0
}

// getters
export const getters = {
  navItems: state => state.navItems,
  mailUnreadCount: state => state.mailUnreadCount,
  chatUnreadCount: state => state.chatUnreadCount
}

// mutations
export const mutations = {
  [types.SET_NAV_ITEMS](state, { navItems }) {
    state.navItems = navItems
  },
  SET_MAIL_UNREAD_COUNT(state, count) {
    state.mailUnreadCount = count
  },
  SET_CHAT_UNREAD_COUNT(state, count) {
    state.chatUnreadCount = count
  },
  HANDLE_CHAT_EVENT(state, payload) {
    // This mutation is subscribed to by ChatLayout for real-time updates
    // The payload is forwarded — no state change needed here
  },
  HANDLE_TYPING_EVENT(state, payload) {
    // Same as above — forwarded to ChatLayout via store.subscribe
  }
}

// actions
export const actions = {
  setNavItems({ commit, dispatch }, { navItems }) {
    commit(types.SET_NAV_ITEMS, { navItems })
  },
  async fetchMailUnreadCount({ commit }) {
    try {
      const { data } = await axios.get('/api/mail/unread-count')
      commit('SET_MAIL_UNREAD_COUNT', data.count || 0)
    } catch (e) {
      // Silently ignore - user may not have mail access
    }
  },
  setMailUnreadCount({ commit }, count) {
    commit('SET_MAIL_UNREAD_COUNT', count)
  },
  async fetchChatUnreadCount({ commit }) {
    try {
      const { data } = await axios.get('/api/chat/unread-count')
      commit('SET_CHAT_UNREAD_COUNT', data.count || 0)
    } catch (e) {
      // Silently ignore - user may not have chat access
    }
  },
  handleChatEvent({ commit }, payload) {
    commit('HANDLE_CHAT_EVENT', payload)
  },
  handleTypingEvent({ commit }, payload) {
    commit('HANDLE_TYPING_EVENT', payload)
  }
}


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
